import _ from 'lodash';

import {
  PENDING_CHANGES_AUTHORS_HEADER,
  PENDING_CHANGES_AUTHORS_HEADER_EXCLUDED_URL_PARTS,
} from 'constants/pendingChangesAuthors';

// Owned by the store (see pendingChangesAuthorsHeader.middleware) so the http layer never imports it.
const pendingChangesAuthorsHeaderState = { value: null };

export const setPendingChangesAuthorsHeaderValue = value => {
  pendingChangesAuthorsHeaderState.value = value;
};

const checkIsExcludedUrl = url =>
  PENDING_CHANGES_AUTHORS_HEADER_EXCLUDED_URL_PARTS.some(part => String(url ?? '').includes(part));

export const applyPendingChangesAuthorsHeader = config => {
  const { value } = pendingChangesAuthorsHeaderState;

  if (_.isNil(value) || checkIsExcludedUrl(config.url)) {
    return config;
  }

  config.headers = config.headers ?? {};
  config.headers[PENDING_CHANGES_AUTHORS_HEADER] = value;

  return config;
};
